import React from 'react';
import {connect} from 'react-redux';
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";
import {baggageFilterSelect, clearFilter} from "../../actions/FlightsActions";
import {bindActionCreators} from "redux";
import {registerAppliedFilter} from "../../actions/FilterGroupsActions";
import BaseFilterComponent from "./BaseFilterComponent";

class BaggageBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = 'baggage';
        this.name = 'Registered baggage';
        this.urlEnabled = props.freeBaggage &&
            (props.urlFilters.baggage.included === false
                || props.urlFilters.baggage.excluded === false);
    }

    checkField(fieldName, e) {
        this.props.baggageFilterSelect(fieldName);
    }

    render() {
        if (this.props.freeBaggage === false) {
            return null;
        }

        const translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div>
                <div className={`no-bottom-border card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="font-weight-bold mb-2">{translator.trans(this.name)}</div>
                    {this.renderClearFilterButton()}
                    <div className="form-check">
                        <label className="form-check-label">
                            <input
                                checked={this.props.selected.included}
                                onChange={this.checkField.bind(this, 'include')}
                                className="form-check-input" type="checkbox"
                                value="1"/>
                            <small>{translator.trans('Included')}</small>
                        </label>
                    </div>
                    <div className="form-check">
                        <label className="form-check-label">
                            <input
                                checked={this.props.selected.excluded}
                                onChange={this.checkField.bind(this, 'exclude')}
                                className="form-check-input" type="checkbox"
                                value="1"/>
                            <small>{translator.trans('Excluded')}</small>
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        baggageFilterSelect,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        freeBaggage: state.BaggageFilterReducer.freeBaggage,
        selected: state.BaggageFilterReducer.selected,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BaggageBlock);



// WEBPACK FOOTER //
// ./src/components/filters/BaggageBlock.js